import { Box, IconButton, useTheme } from "@mui/material";
// import { useContext } from "react";
import { coloring } from "../GlobalTheme";
import InputBase from "@mui/material/InputBase";
// import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
// import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import SearchIcon from "@mui/icons-material/Search";
// import WalletConnect from "../components/Wallet";

const Topbar = () => {
  const theme = useTheme();
  const colors = coloring(theme.palette.mode);
  // const colorMode = useContext(ColorModeContext);

  return (
    <Box display="flex" justifyContent="space-between" p={2}>
      <Box
        display="flex"
        backgroundColor={colors.green[800]}
        borderRadius="3px"
      >
        <InputBase sx={{ ml: 2, flex: 1 }} placeholder="Search" />
        <IconButton type="button" sx={{ p: 1 }}>
          <SearchIcon />
        </IconButton>
        {/* <WalletConnect/> */}
      </Box>
      
    </Box>
  );
};

export default Topbar;

